import {AxiosInstance} from "axios";
import StatusRepositoryInterface from "@/services/Bug-report/Settings/interfaces/status.repository";
import {CreateStatusDTO, StatusEntity, UpdateStatusDTO} from "@fenix/bug-report-entities/bug-report-entities";

export default class StatusRepository implements StatusRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  async create(DTOs: CreateStatusDTO[]): Promise<StatusEntity[]> {
    const url = '/bug-report/bugs/status';
    const res = await this.axios.post(url, DTOs);
    return res.data;
  }

  async getOne(id: number, relations?: string[]): Promise<StatusEntity> {
    const url = `/bug-report/bugs/status/${id}${relations && relations?.length ? `?relations=${relations.toString()}` : ''}`;

    const res = await this.axios.get(url);
    return res.data;
  }

  async updateOne(id: number, dto: UpdateStatusDTO): Promise<StatusEntity> {
    const url = `/bug-report/bugs/status/${id}`;

    const res = await this.axios.patch(url, dto);
    return res.data;
  }

  async deleteOne(id: number): Promise<void> {
    const url = `/bug-report/bugs/status/${id}`;
    const res = await this.axios.delete(url);

    return res.data;
  }

  async getAll(page?: number, take?: number): Promise<StatusEntity[]> {
    const url = `/bug-report/bugs/status?page=${page ?? ''}&take=${take ?? ''}`;

    const res = await this.axios.get(url);
    return res.data;
  }
}
